import baseFetch from './baseFetch';


export default async function() {
    const request = await baseFetch("api/additional_service", {
        method: "GET",
    });
    return await request;
}
